import { unit } from '../../common/theme';
import { styled } from '../../providers/context/StyletronProvider/withStyletronProvider';

export const ErrorWrapper = styled('div', {
  marginTop: unit[3],
});
